import '../../style/index.less';
import './index.less'; // style dependencies
// deps-lint-skip: input

import '../../input/style';
import '../../time-picker/style';
import '../../tag/style';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/style/index.js
// module id = 815
// module chunks = 0